module.exports = __webpack_public_path__ + "2b116d670c2ee9b03d45ec6cc49d1f0e.jpg";